import { useState } from "react";
import type { ListerResearch } from "../../../lib/api";
import { fmtCents } from "../../../lib/format";

export default function EvidenceDrawer({ research }: { research: ListerResearch }) {
  const [open, setOpen] = useState(false);
  const groups = new Map<string, ListerResearch["evidence"]>();
  for (const e of research.evidence) groups.set(e.source, [...(groups.get(e.source) ?? []), e]);
  return (
    <div className="font-mono text-sm">
      <button onClick={() => setOpen(!open)} className="text-zinc-300 underline text-xs">{open ? "hide" : "show"} evidence ({research.evidence.length} records, {research.sources_ok.length} sources)</button>
      {open && (
        <div className="mt-2 space-y-3 max-h-96 overflow-auto">
          {[...groups].map(([source, rows]) => (
            <div key={source}><div className="text-zinc-400 text-xs">{source} · {rows.length}</div>
              <ul className="space-y-0.5">{rows.slice(0, 20).map((e) => <li key={e.id} className="text-xs text-zinc-300 truncate">{e.url && /^https?:/i.test(e.url) ? <a href={e.url} target="_blank" rel="noopener" className="underline">{e.title ?? e.id}</a> : e.title ?? e.id}{e.price_cents !== undefined && <span className="text-zinc-500"> · {fmtCents(e.price_cents)} {e.price_kind}</span>}{e.condition && <span className="text-zinc-500"> · {e.condition}</span>}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {research.sources_failed.length > 0 && <ul className="mt-2 text-xs text-zinc-500">{research.sources_failed.map((f) => <li key={f.source}>{f.source}: not available ({f.reason})</li>)}</ul>}
    </div>
  );
}
